import React from 'react';

const Buyer = ({username, endDate, allowContact, notify, notifyBuyer, clickContact}) => (
    <div className="content buyer-view">
        <h3 className="title" dangerouslySetInnerHTML={{ __html: i18n.t('out_of_office.banner.buyer.is_out', {username, endDate}) }}></h3>
        {allowContact && (
            <p className="notice">
                {i18n.t('out_of_office.banner.buyer.meantime')}
                <a href={`/conversations/${username}`} className="js-contact-me" onClick={clickContact}>{i18n.t('out_of_office.banner.buyer.contact')}</a> {username}
            </p>
        )}
        {!allowContact && notify && <p className="notice">{i18n.t('out_of_office.banner.buyer.notify', {username})}</p>}
        {!allowContact && !notify && <p className="notice">
            {i18n.t('out_of_office.banner.buyer.notify_me_1')}
            <a onClick={notifyBuyer}>here</a>
            {i18n.t('out_of_office.banner.buyer.notify_me_2', {username})}
        </p>}
    </div>
);

export default Buyer;


// WEBPACK FOOTER //
// ./src/GigBanner/Buyer.js